import {
    SetProjectContentItemIsHiddenInput,
    ViewItemReorderInput,
} from '@deltek/specification-client/core/Models/projectProductFamily'
import { ViewItemReorderPTPInput } from '@deltek/specification-client/core/Models/projectProductTypeProperty'
import { useCallback } from 'react'
import {
    useReorderFamilyTemplatesMutation,
    useReorderProductTypeTemplatesMutation,
    useShowHideMutation,
} from '../api/mutations/hoveredItemActionsMutations'

export const useHoveredActionMutationService = () => {
    const { setProjectContentItemHidden } = useShowHideMutation()
    const { reorderFamilyTemplates } = useReorderFamilyTemplatesMutation()
    const {
        reorderProductTypeTemplates,
    } = useReorderProductTypeTemplatesMutation()

    /** Async mutation to update the content item element */
    const mutateDeactivationAsync = useCallback(
        async (
            setProjectContentItemIsHiddenInput: Partial<
                SetProjectContentItemIsHiddenInput
            >
        ) => {
            return await setProjectContentItemHidden({
                variables: {
                    SetProjectContentItemIsHiddenInput: setProjectContentItemIsHiddenInput,
                },
            })
        },
        [setProjectContentItemHidden]
    )

    /** Async mutation to reorder family templates */
    const mutateReorderFamilyTemplatesAsync = useCallback(
        async (reOrderFamilyContentInput: Partial<ViewItemReorderInput>) => {
            return await reorderFamilyTemplates({
                variables: { reOrderFamilyContentInput },
            })
        },
        [reorderFamilyTemplates]
    )

    /** Async mutation to reorder product type templates */
    const mutateReorderProductTypeTemplatesAsync = useCallback(
        async (reOrderPTContentInput: Partial<ViewItemReorderPTPInput>) => {
            return await reorderProductTypeTemplates({
                variables: { reOrderPTContentInput },
            })
        },
        [reorderProductTypeTemplates]
    )

    // Return all the mutations in a single object
    return {
        mutateDeactivationAsync,
        mutateReorderFamilyTemplatesAsync,
        mutateReorderProductTypeTemplatesAsync,
    }
}
